import { P } from '@src/components/atoms/paragraph';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { ResponsiveText } from 'src/components/common/formatting/responsive-text';

import { InfiniteGallery } from './infinite-gallery';
import { HeaderContent, HeaderTitle, LoggedOutHeader, SignUpCTA } from './styles';

export const SignInAndBook = () => {
  const content = useCmsContent();
  return (
    <LoggedOutHeader>
      <HeaderTitle>
        <h1>
          <ResponsiveText text={content.noUpcomingTripsTitle} id="noUpcomingTripsTitle" />
        </h1>

        <P $noMargin $isCentered>
          {content.noUpcomingTripsDescription}
        </P>
      </HeaderTitle>

      <HeaderContent>
        <SignUpCTA size="small" href="/auth">
          {content.signInSignUpCta}
        </SignUpCTA>
        <InfiniteGallery />
      </HeaderContent>
    </LoggedOutHeader>
  );
};
